import {
  DataGrid,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { Grid, TablePagination, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useStateValue } from "../../../../Hooks/stateProvider";
import axios from "axios";
import { ls } from "../../../../variables";
import { encrypt } from "../../../../utils/cipher";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { LightTooltip } from "../../../../components/LightTooltip";
import { errorHandler } from "../../../../utils/errorHandling";
import CustomNoRowsOverlay from "../../../../components/CustomNoRowsOverlay";
import AlertFinalSubmission from "./AlertFinalSubmission";
import Loader from "../../../../Loader/Loader";

export default function TrakerTable(props) {
  const navigate = useNavigate();
  const [{ fileName, fileDetails }, dispatch] = useStateValue();
  const [receivedData, setReceivedData] = useState();
  const [openModal, setOpenModal] = useState();
  const [payload, setPayload] = useState();
  const tableData = props.tableData;
  const annexureType = props.GTtype;
  let tempRows;
  const email = ls.get("email");
  const userName = ls.get("userName");
  const pmsCode=ls.get("pmsName")
  const originalPMSName=ls.get("originalPMSName")

  useEffect(() => {
    (async function () {
      const formData = new FormData();
      const payload = {
        fy_year: props.tableData[0]?.fy_year,
        quarter: props.tableData[0]?.quarter,
        pmsDetails: [originalPMSName,pmsCode],
        statusCheck: true,
        email: email,
        userName: userName,
        // year:year,
        // previousMonth:previousMonth,
        // month:monthName,
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      const encryptedFormData = await encrypt(payload);
      formData.append("file", fileDetails);
      formData.append("fileName", fileName);
      formData.append("payload", encryptedFormData);
      const encryptedHeaders = await encrypt({
        authtoken: ls.get("authToken"),
        refreshtoken: ls.get("refreshToken"),
      });
      axios
        .post("/api/pms/trackerFinalSubmit", formData, {
          withCredentials: true,
          headers: {
            headers: encryptedHeaders,
          }
        })
        .then((receivedData) => {
          setReceivedData(receivedData.data.value);

        })
        .catch((err) => {
          errorHandler(err, navigate)
        })
    })();
  }, [])

  const handleSubmit = () => {
    setPayload({
      ticket_id: props.tableData[0]?.ticket_id,
      pmsDetails: [originalPMSName,pmsCode],
      fy_year: props.tableData[0]?.fy_year,
      quarter: props.tableData[0]?.quarter,
      statusCheck: false,
      email: email,
      userName: userName,
      // year:year,
      // previousMonth:previousMonth,
      // month:monthName,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    });
    setOpenModal(true);
  };

  const CustomFooter = ({ onSendClick }) => {
    const apiRef = useGridApiContext();
    const paginationModel = useGridSelector(
      apiRef,
      gridPaginationModelSelector
    );
    return (
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "52px",
        }}
      >
        <Grid item xs={3}></Grid>
        <Grid item xs={6} sx={{ textAlign: "center" }}>
          <LightTooltip title={receivedData > 0 ? `Close all ${receivedData} annexures before final submission` : ""} placement="top">
            <span><button
              style={{
                color: "#ffffff",
                marginLeft: "10px",
                height: "1.875rem",
                width: "8.125rem",
                backgroundColor: receivedData == 0 && props?.tableData.length > 0 && props?.tableData.every((val) => val.alert_status == "pending") ? "#154063" : "#808080",
                borderColor: receivedData == 0 && props?.tableData.length > 0 && props?.tableData.every((val) => val.alert_status == "pending") ? "#154063" : "#808080",
                cursor: receivedData == 0 && props?.tableData.length > 0 && props?.tableData.every((val) => val.alert_status == "pending") ? "pointer" : "default",
              }}
              disabled={receivedData == 0 && props?.tableData.length > 0 && props?.tableData.every((val) => val.alert_status == "pending") ? false : true}
              onClick={handleSubmit}
            >
              Submit
            </button></span>
          </LightTooltip>
        </Grid>
        <Grid item xs={3}>
          <TablePagination
            component="div"
            className="table_pagination"
            count={rows.length}
            page={paginationModel.page}
            onPageChange={(event, value) => apiRef.current.setPage(value)}
            rowsPerPage={paginationModel.pageSize}
            rowsPerPageOptions={[]}
          />
        </Grid>
      </Grid>
    );
  };

  const columns = [
    {
      field: "unreadAlert",
      headerName: "",
      minWidth: 30,
      maxWidth: 40,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {params.row.alert_status == "open" && <PriorityHighIcon />}
          </div>)
      }
    },
    {
      field: "guidance_type",
      headerName: "Guidance Type",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
    },
    {
      field: "instance_count",
      headerName: "Instance Count",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "view",
      headerName: "Details",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ paddingRight: "5px" }}>
              <button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#154063",
                  border: "0.125rem solid #154063",
                  borderRadius: "0.125rem",
                  width: "6.5rem",
                  cursor: "pointer",
                  height: "1.875rem",
                }}
                onClick={() => {
                  dispatch({
                    type: "PMSTrackerPageData",
                    PMSTrackerPageData: {
                      ticketID: params.row.ticket_id,
                      instanceCount: params.row.instance_count,
                      guidanceType: params.row.guidance_type,
                      pmsTrackerViewStatus: params.row.alert_status,
                      caseIdCount: params.row.closed_instance_count
                    },
                  });
                  navigate("/app/trackerView");
                }}
              >
                View
              </button>
            </div>
          </div>
        );
      },
    },
    {
      field: "alert_status",
      headerName: "Status",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ fontSize: "1rem" }}>
            {params.row.alert_status == "open" || params.row.alert_status == "open (sebi)" ? "open" : params.row.alert_status}
          </div>)
      }
    },
  ];

  if (annexureType != "") {
    tempRows = tableData.filter((val) =>
      annexureType.includes(val.guidance_type)
    );
  } else {
    tempRows = tableData;
  }

  const rows = tempRows.map((val, i) => ({ id: i + 1, ...val }));

  return (
    (<div style={{ height: "100%", width: "100%", marginTop: "0%" }}>
      <Loader />
      <DataGrid
        getRowHeight={() => "auto"}
        rows={tempRows ? rows : tableData}
        columns={columns}
        sx={{
          width: "fit-content",
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
            backgroundColor: "#154063",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
          "& .MuiDataGrid-topContainer": { width: "fit-content" },
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
          "& .MuiDataGrid-overlayWrapper": {
            position: "static"
          }
        }}
        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
          footer: CustomFooter,
        }}
        // footer={{
        //   render: (params) => <CustomFooter />,
        // }}
        rowsPerPageOptions={[2, 5, 10]}
        AutoGenerateColumns={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        disableColumnSelector
        scrollbarSize={0}
        autoPageSize
      />
      {openModal && <AlertFinalSubmission payload={payload} openModal={openModal} setOpenModal={setOpenModal} handlePreviewClick={props.handlePreviewClick} />}
    </div>)
  );
}
